import { Component, effect, EventEmitter, Inject, Input, OnInit, Output } from "@angular/core";
import { UntypedFormGroup, Validators } from "@angular/forms";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { LocalizationService } from "src/core/utilitites/localization.service";
import { Calender, CustDateAdapter } from "../../../followup-schedule/Calender";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MyFormat } from "../date-format/my-date-format";
import { HelperService, IdentifierService } from "merlin-core";
import { Subscription } from "rxjs";
import {
    debounceTime,
    distinctUntilChanged,
    take,
} from 'rxjs/operators';
import { UserProfileObject, UserService } from "merlin-library";
import { isMoment } from "moment-timezone";
@Component({
    selector: 'app-smart-followup',
    styleUrls: ['./smart-followup.component.scss'],
    templateUrl: './smart-followup.component.html',
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
        {
            provide: DateAdapter,
            useClass: CustDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useClass: MyFormat },
    ],
    standalone: false
})

export class SmartFollowupComponent implements OnInit {
    @Input() followupScheduleForm: UntypedFormGroup;
    @Input() lastTransMissionDate: string;
    @Input() patientData: any;
    smartScheduleForm: UntypedFormGroup;
    permScheduleForm: UntypedFormGroup;
    tempScheduleForm: UntypedFormGroup;
    userProfile: UserProfileObject;
    datePlaceholder ='';
    @Input() locale: string;
    @Input() tz: string;
    calenderHeader = Calender;
    localeSubscription: Subscription;
    dateClass = (cellDate, view) => {
        if (![null, ''].includes(cellDate)) {
            const date = cellDate.date();
            const today = this.helperService.getCurrentDateByTimeZone(this.tz);
            let cellClass = today.getDate() === date &&
                today.getMonth() == new Date(cellDate).getMonth() &&
                today.getFullYear() == new Date(cellDate).getFullYear()
                ? 'current__date' : 'no_current_date';
            return (new Date(cellDate).getDay() == 6 || new Date(cellDate).getDay() == 0) ? cellClass + ' weekend-day' : cellClass
        }
        return '';
    };

    public stringLabels = [
        "label.gb.perm_sched",
        "label.gb.starting_on",
        "label.gb.the",
        "label.gb.of",
        "label.gb.transmit_every",
        "label.gb.for",
        "label.gb.bring_pat_in_clinic",
        "label.gb.switch_to_temp_sched",
        "label.gb.starting_on",
        "label.gb.revert_to_perm_sched",
    ];

    public labels: Record<string, string>;
    @Output() permStartDateString = new EventEmitter<string>();
    @Output() tempStartDateString = new EventEmitter<string>();

    constructor(
        private localizationService: LocalizationService,
        private _adapter: DateAdapter<any>,
        @Inject(MAT_DATE_LOCALE) private _locale: string,
        @Inject(MAT_DATE_FORMATS) private config: MyFormat,
        @Inject(DateAdapter) private dateAdapter: CustDateAdapter,
        public userService: UserService,
        private helperService: HelperService,
        public identifierService: IdentifierService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
        this.config.value = 1;
        this.userService
        .getUserObs()
        .pipe(take(1))
        .subscribe((userProfile: UserProfileObject) => {
            this.userProfile = userProfile;
        });
    }


    ngOnInit(): void {
        this.translateStrings();
        this.dateAdapter.setLocale(this.locale);
        this.datePlaceholder = this.userProfile.dateFormat.toUpperCase();
        this.smartScheduleForm = this.followupScheduleForm.get('smartSchedule') as UntypedFormGroup;
        this.permScheduleForm = this.smartScheduleForm.get('permSchedule') as UntypedFormGroup;
        this.tempScheduleForm = this.smartScheduleForm.get('tempSchedule') as UntypedFormGroup;
        Object.keys(this.permScheduleForm.controls).forEach((control: string) => {
            this.permScheduleForm.controls[control].valueChanges.pipe(debounceTime(1000),
                distinctUntilChanged()).subscribe(() => {
                    this.permScheduleForm.get('schdChangedFlg').setValue(this.permScheduleForm.dirty);
                })
        })
        Object.keys(this.tempScheduleForm.controls).forEach((control: string) => {
            this.tempScheduleForm.controls[control].valueChanges.pipe(debounceTime(1000),
                distinctUntilChanged()).subscribe(() => {
                    this.tempScheduleForm.get('schdChangedFlg').setValue(this.tempScheduleForm.dirty);
                })
        })
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
        this.parseCodeLabels(this.patientData
                .codes
                .transmitWeekCodes);
        this.parseCodeLabels(this.patientData
                .codes
                .transmitDayCodes);
        this.parseCodeLabels(this.patientData
                .codes
                .transmitMonthCodes);
        this.parseCodeLabels(this.patientData
                  .codes
                  .permSchdFrequencyCodes);
        this.parseCodeLabels(this.patientData
                  .codes
                  .permSchdDurationCodes);
        this.parseCodeLabels(this.patientData
                  .codes
                  .tempSchdFrequencyCodes);
        this.parseCodeLabels(this.patientData
                  .codes
                  .tempSchdDurationCodes);
        
    }

    appendStringsToLabelList(listToAppend: string[]){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, listToAppend);
    }

    parseCodeLabels(codes){
        let stringToAppend = []

        for(let option of codes){
            stringToAppend.push('data.Code.'+option.qualifier+'.Code_Desc.'+ option.code);
        }

        this.appendStringsToLabelList(stringToAppend);
    }

    shouldView(){
        return this.patientData.codes.permSchdDurationCodes.find((code)=> code.codeId == this.permScheduleForm.get('durationCd').value)?.code != '0M';
    }

    translatePlaceHolder(): string {
        let key = this.datePlaceholder?.toUpperCase() == 'DD-MM-YYYY'
            ? 'label.gb.ddmmyyyy' :
            this.datePlaceholder?.toUpperCase() == 'MM-DD-YYYY'
                ? 'label.gb.mmddyyyy' : 'label.gb.yyyymmdd';
        return this.localizationService.generateLocalizedStr(key);
    }

    getTooltipText() {
        return this.localizationService.generateLocalizedStr('msg.gb.sched_forlife_rollover', null, 'html')
    }

    onToggleTempSelection($event) {
        if ($event.checked) {
            this.tempScheduleForm.enable();
            let value = this.tempScheduleForm.get('calculateFlg').value;
            this.tempRadioChange({ value:  value})
        } else {
            this.tempScheduleForm.disable();
        }
        Object.keys(this.tempScheduleForm.controls).forEach(key => {
            this.tempScheduleForm.controls[key].markAsUntouched();
        });
    }

    isCheckedPermSchedule(value: boolean) {
        return this.permScheduleForm.get('calculateFlg').value == value;
    }
    isTempScheduleChecked(value: boolean) {
        return this.tempScheduleForm.get('calculateFlg').value == value;
    }

    radioChange($event) {
        if ($event.value?.toString() == 'false') {
            this.permScheduleForm.get('startDate').setValue('');
            this.permScheduleForm.get('startDate').disable();
            this.permScheduleForm.get('transmitOnWeekCd').enable();
            this.permScheduleForm.get('transmitOnDayCd').enable();
            this.permScheduleForm.get('transmitOnMonthCd').enable();

            
            this.permScheduleForm.get('transmitOnMonthCd').setValidators([Validators.required]);
            this.permScheduleForm.get('startDate').clearValidators();
            this.permScheduleForm.get('transmitOnWeekCd').setValidators([Validators.required]);
            this.permScheduleForm.get('transmitOnDayCd').setValidators([Validators.required]);
            

            this.permScheduleForm.get('frequencyCd').setValidators([Validators.required]);
            this.permScheduleForm.get('durationCd').setValidators([Validators.required]);
            
            this.permScheduleForm.get('transmitOnMonthCd').updateValueAndValidity();
            this.permScheduleForm.get('startDate').updateValueAndValidity();
            this.permScheduleForm.get('transmitOnWeekCd').updateValueAndValidity();
            this.permScheduleForm.get('transmitOnDayCd').updateValueAndValidity();
            

            this.permScheduleForm.get('frequencyCd').updateValueAndValidity();
            this.permScheduleForm.get('durationCd').updateValueAndValidity();
            
        } else {
            this.permScheduleForm.get('transmitOnWeekCd').setValue('');
            this.permScheduleForm.get('transmitOnDayCd').setValue('');
            this.permScheduleForm.get('transmitOnMonthCd').setValue('');

            this.permScheduleForm.get('startDate').enable();
            this.permScheduleForm.get('transmitOnWeekCd').disable();
            this.permScheduleForm.get('transmitOnDayCd').disable();
            this.permScheduleForm.get('transmitOnMonthCd').disable();

            this.permScheduleForm.get('startDate').setValidators([Validators.required]);
            this.permScheduleForm.get('transmitOnWeekCd').clearValidators();
            this.permScheduleForm.get('transmitOnDayCd').clearValidators();
            this.permScheduleForm.get('transmitOnMonthCd').clearValidators();
            this.permScheduleForm.get('frequencyCd').setValidators([Validators.required]);
            this.permScheduleForm.get('durationCd').setValidators([Validators.required]);

            this.permScheduleForm.get('startDate').updateValueAndValidity();
            this.permScheduleForm.get('transmitOnWeekCd').updateValueAndValidity();
            this.permScheduleForm.get('transmitOnDayCd').updateValueAndValidity();
            this.permScheduleForm.get('transmitOnMonthCd').updateValueAndValidity();

            this.permScheduleForm.get('frequencyCd').updateValueAndValidity();
            this.permScheduleForm.get('durationCd').updateValueAndValidity();
        }
        Object.keys(this.permScheduleForm.controls).forEach(key => {
            this.permScheduleForm.controls[key].markAsUntouched();
        });
    }

    tempRadioChange($event) {
        if ($event.value?.toString() == 'false') {
            this.tempScheduleForm.get('startDate').setValue('')
            this.tempScheduleForm.get('startDate').disable();
            this.tempScheduleForm.get('transmitOnWeekCd').enable();
            this.tempScheduleForm.get('transmitOnDayCd').enable();
            this.tempScheduleForm.get('transmitOnMonthCd').enable();

            this.tempScheduleForm.get('startDate').clearValidators();
            this.tempScheduleForm.get('transmitOnWeekCd').setValidators([Validators.required]);
            this.tempScheduleForm.get('transmitOnDayCd').setValidators([Validators.required]);
            this.tempScheduleForm.get('transmitOnMonthCd').setValidators([Validators.required]);

            this.tempScheduleForm.get('frequencyCd').setValidators([Validators.required]);
            this.tempScheduleForm.get('durationCd').setValidators([Validators.required]);

            this.tempScheduleForm.get('startDate').updateValueAndValidity();
            this.tempScheduleForm.get('transmitOnWeekCd').updateValueAndValidity();
            this.tempScheduleForm.get('transmitOnDayCd').updateValueAndValidity();
            this.tempScheduleForm.get('transmitOnMonthCd').updateValueAndValidity();
            this.tempScheduleForm.get('frequencyCd').updateValueAndValidity();
            this.tempScheduleForm.get('durationCd').updateValueAndValidity();
        } else {
            this.tempScheduleForm.get('transmitOnWeekCd').setValue('');
            this.tempScheduleForm.get('transmitOnDayCd').setValue('');
            this.tempScheduleForm.get('transmitOnMonthCd').setValue('');

            this.tempScheduleForm.get('startDate').enable();
            this.tempScheduleForm.get('transmitOnWeekCd').disable();
            this.tempScheduleForm.get('transmitOnDayCd').disable();
            this.tempScheduleForm.get('transmitOnMonthCd').disable();

            this.tempScheduleForm.get('frequencyCd').setValidators([Validators.required]);
            this.tempScheduleForm.get('durationCd').setValidators([Validators.required]);

            this.tempScheduleForm.get('startDate').setValidators([Validators.required]);
            this.tempScheduleForm.get('transmitOnWeekCd').clearValidators();
            this.tempScheduleForm.get('transmitOnDayCd').clearValidators();
            this.tempScheduleForm.get('transmitOnMonthCd').clearValidators();

            this.tempScheduleForm.get('startDate').updateValueAndValidity();
            this.tempScheduleForm.get('transmitOnWeekCd').updateValueAndValidity();
            this.tempScheduleForm.get('transmitOnDayCd').updateValueAndValidity();
            this.tempScheduleForm.get('transmitOnMonthCd').updateValueAndValidity();
            this.tempScheduleForm.get('frequencyCd').updateValueAndValidity();
            this.tempScheduleForm.get('durationCd').updateValueAndValidity();
        }
        Object.keys(this.tempScheduleForm.controls).forEach(key => {
            this.tempScheduleForm.controls[key].markAsUntouched();
        });
    }

    emptyPermDropDowns() {

    }
    tempPickerActive() {
        return false;
    }
    emptyTempStartDate() {

    }
    tempFreqDurActive() {
        return false;
    }

    matcher: boolean = false;
    setOnCallDropdownError(state: boolean){
        this.matcher = state;
    }

    onPermStartDateChange(evt){
        this.permStartDateString.emit(isMoment(evt) ? evt.format(this.datePlaceholder.toUpperCase()) : evt);
    }

    onTempStartDateChange(evt){
        this.tempStartDateString.emit(isMoment(evt) ? evt.format(this.datePlaceholder.toUpperCase()) : evt);
    }
    
}